
class DashboardMainController {

  /* @ngInject */
  constructor(LoginService, $rootScope, scaTypeConstants) {
    const that = this;
    this.name = 'dashboardMain';
    this.scaRequired = false


    const init = () => {
      checkSca()
    };

    that.$onInit = init;

    const checkSca = () => {
      if (MODE === "admin") {
        this.scaRequired = false;
        return;
      }

      if(!LoginService.getUserRole().includes('ROLE_SCA_'+scaTypeConstants.LOGIN)){
        this.scaRequired = true
      }else{
        this.scaRequired = false
      }
    }
    
    $rootScope.$on('POLLER_SCA_COMPLETED_TYPE_'+scaTypeConstants.LOGIN, checkSca);
  }
}

export default DashboardMainController;



/** WEBPACK FOOTER **
 ** ./client/app/components/dashboard/main/main.controller.js
 **/